module.exports = __webpack_public_path__ + "static/mobile-hybrid.7643f862.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Page/img/mobile-hybrid.png
// module id = 803
// module chunks = 207607843663661